module.exports = __webpack_public_path__ + "static/img/floorEvery.79339dc4.png";